import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-alert-message-popover',
  templateUrl: './alert-message-popover.component.html',
  styleUrls: ['./alert-message-popover.component.css']
})
export class AlertMessagePopoverComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
